import { render, staticRenderFns } from "./CustomOrthosesCustomizationModal.vue?vue&type=template&id=556596a3&"
import script from "./CustomOrthosesCustomizationModal.vue?vue&type=script&lang=js&"
export * from "./CustomOrthosesCustomizationModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomOrthosesCustomizationModal.vue?vue&type=style&index=0&id=556596a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports